import { ContextMenuItem } from "@/components/ui/context-menu";

interface Props extends React.ComponentProps<"div"> {
  rightClickedElement: HTMLElement;
}

const ChartContextActions: React.FC<Props> = ({ rightClickedElement }) => {
  const removeChart = () => {
    const chartContainer =
      rightClickedElement.dataset.type === "chart"
        ? rightClickedElement
        : (rightClickedElement.closest(
            '[data-type="chart"]'
          ) as HTMLElement | null);

    if (!chartContainer) return;

    const trailing = chartContainer.nextSibling;

    chartContainer.remove();

    if (trailing && trailing.nodeName === "BR" && trailing.parentElement) {
      trailing.parentElement.removeChild(trailing);
    }
  };

  return (
    <ContextMenuItem className="text-red-500" onClick={removeChart}>
      حذف چارت
    </ContextMenuItem>
  );
};

export default ChartContextActions;
